module.exports = __webpack_public_path__ + "static/media/clinicName.ace6e481.svg";